/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { feedItemSchema } from '../getFeed/get-feed-request';

export const feedItemV2Schema = feedItemSchema.extend({
  queueSource: z.enum(['onboarding', 'random']),
  hasVideo: z.boolean(),
});

export type IFeedItemV2 = z.infer<typeof feedItemV2Schema>;

export const getFeedV2ResponseDataSchema = z.array(feedItemV2Schema);

export type IGetFeedV2ResponseData = z.infer<typeof getFeedV2ResponseDataSchema>;

export const getFeedV2ResponseSchema = createApiResponseSchema(
  getFeedV2ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetFeedV2ResponseData>>;

export type IGetFeedV2Response = IAPI<IGetFeedV2ResponseData>;
